import ApiService from "../../util/ApiService";
import {
  GET_HOME,
  GET_HOME_SUCCESS,
  GET_HOME_ERROR,
  GET_BOOKMARKS,
  GET_BOOKMARKS_SUCCESS,
  GET_BOOKMARKS_ERROR,
  GET_FOLLOWED_ALERTS_REQUEST,
  GET_FOLLOWED_ALERTS_SUCCESS,
  GET_FOLLOWED_ALERTS_ERROR,
} from "../../constants/actionTypes";

export const fetchHome = async (dispatch) => {
  dispatch({ type: GET_HOME });
  try {
    const response = await ApiService.get("/v1/");
    dispatch({ type: GET_HOME_SUCCESS, payload: response.data });
  } catch {
    dispatch({ type: GET_HOME_ERROR });
  }
};

// Bookmark is already deleted from backend, this just removes it from the store
export const fetchBookmarks = async (dispatch, an) => {
  dispatch({ type: GET_BOOKMARKS });
  try {
    const response = await ApiService.get("/v1/bookmarks");
    dispatch({ type: GET_BOOKMARKS_SUCCESS, payload: response.data });
  } catch {
    dispatch({ type: GET_BOOKMARKS_ERROR });
  }
};

export const fetchAlerts = async (dispatch) => {
  dispatch({ type: GET_FOLLOWED_ALERTS_REQUEST });
  try {
    const response = await ApiService.get(
      "/v1/alerts?limit=10&type=followed&ppcDataset=true"
    );
    dispatch({
      type: GET_FOLLOWED_ALERTS_SUCCESS,
      payload: response.data,
    });
  } catch {
    dispatch({ type: GET_FOLLOWED_ALERTS_ERROR });
  }
};
